import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImage } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Loader2 } from "lucide-react";

export default function AdminBlogList() {
  const [items, setItems] = useState(null);

  const load = async () => {
    const { data } = await api.get("/admin/blog");
    setItems(data);
  };
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/blog");
        setItems(data);
      } catch (_err) { /* ignore */ }
    })();
  }, []);

  const remove = async (slug, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    try {
      await api.delete(`/admin/blog/${slug}`);
      toast.success("Deleted");
      load();
    } catch {
      toast.error("Failed to delete");
    }
  };

  return (
    <div className="p-10 lg:p-16" data-testid="admin-blog-list">
      <div className="flex items-center justify-between mb-12">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#73706B] mb-3">
            — Manage
          </p>
          <h1
            className="text-5xl font-light"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Blog
          </h1>
        </div>
        <Link
          to="/admin/blog/new"
          data-testid="admin-new-post"
          className="inline-flex items-center gap-2 bg-[#1A1A1A] text-[#F9F6F0] px-6 py-3 text-[10px] tracking-[0.25em] uppercase hover:bg-[#C5A880] transition-colors"
        >
          <Plus className="w-3.5 h-3.5" strokeWidth={1.5} /> New Post
        </Link>
      </div>

      {items === null ? (
        <Loader2 className="w-6 h-6 animate-spin text-[#C5A880]" strokeWidth={1.5} />
      ) : items.length === 0 ? (
        <p className="text-[#73706B]">No posts yet.</p>
      ) : (
        <div className="border border-[#E5DFD5] bg-[#FFFFFF]">
          {items.map((p) => (
            <div
              key={p.slug}
              data-testid={`admin-post-row-${p.slug}`}
              className="grid grid-cols-12 gap-4 items-center px-6 py-4 border-b border-[#E5DFD5] last:border-b-0"
            >
              <div className="col-span-2 aspect-video bg-[#E5DFD5] overflow-hidden">
                {p.image && <img src={resolveImage(p.image)} alt={p.title} className="w-full h-full object-cover" />}
              </div>
              <div className="col-span-6">
                <p
                  className="text-lg font-light text-[#1A1A1A]"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {p.title}
                </p>
                <p className="text-xs text-[#73706B] mt-1">
                  {p.date} · {p.readTime}
                </p>
              </div>
              <div className="col-span-1 text-xs text-[#73706B]">{p.slug}</div>
              <div className="col-span-3 flex items-center justify-end gap-3">
                <Link
                  to={`/admin/blog/${p.slug}/edit`}
                  data-testid={`admin-edit-post-${p.slug}`}
                  className="inline-flex items-center gap-1 text-[10px] tracking-[0.2em] uppercase border border-[#1A1A1A] text-[#1A1A1A] px-3 py-1.5 hover:bg-[#1A1A1A] hover:text-[#F9F6F0]"
                >
                  <Pencil className="w-3 h-3" strokeWidth={1.5} /> Edit
                </Link>
                <button
                  onClick={() => remove(p.slug, p.title)}
                  data-testid={`admin-delete-post-${p.slug}`}
                  className="text-[#73706B] hover:text-red-700"
                >
                  <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
